// import Footer from '../components/footer/footer';
import Header from '../components/common/header/header';
import ScrollToTop from '../components/common/ScrollToTop';
export const Donate = (props) => {
  return (
    <div className="scrollbar-hidden">
      <Header />

      {/* <Footer /> */}
      <ScrollToTop />
    </div>
  );
};
